import { CabHubTrackingPageVm } from "./scripts/cab-hub-tracking.entities";
import { CabMemberView } from "./scripts/cab-member.view";
import { HubMemberView } from "./scripts/hub-member.view";
import { AdminMemberView } from "./scripts/admin-member.view";

export class CabHubTrackingPage {
    constructor(modelJson: CabHubTrackingPageVm) {
        $(() => {
            if (modelJson.Scope == "cab-member") {
                let cabMemberView = new CabMemberView(modelJson);
                cabMemberView.initialize();
            }
            else if (modelJson.Scope == "hub-member") {
                let hubMemberView = new HubMemberView(modelJson);
                hubMemberView.initialize();
            }
            else if (modelJson.Scope == "admin") {
                let adminView = new AdminMemberView(modelJson);
                adminView.initialize();
            }
        });
    }
}